module.exports = __webpack_public_path__ + "static/media/panda_with_bat_touka.b878b455.png";